import React from 'react'
import {
  TrashIcon,
} from '@heroicons/react/outline'

export default function button({ label, color, ...rest }) {

  switch (color) {
    case 'success':
      return (
        <button {...rest}
          className={`ml-3 flex justify-center items-center  px-8 h-10 text-sm font-medium rounded-md  focus:outline-none focus:ring-0  text-green-700 bg-white  shadow-sm border border-gray-300`}>
          {label}
        </button>
      )
    case 'danger':
      return (
        <button {...rest}
          className="ml-4 rounded-full h-8 w-8 flex items-center justify-center text-gray-400 hover:bg-gray-100 hover:text-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500">
          <TrashIcon className="h-6 w-6" aria-hidden="true" />
        </button>
      )
  }


}
